var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"tabs",class:{
      'is-centered': _vm.centered,
      'is-boxed': _vm.boxed,
      'is-toggle': _vm.toggle,
      'is-toggle-rounded': _vm.rounded
    }},[_c('ul',_vm._l((_vm.tabs),function(tab,key){return _c('li',{key:key,class:{ 'is-active': _vm.value === key },on:{"click":function($event){return _vm.$emit('input', key)}}},[_c('a',[(tab.icon)?_c('icon',{attrs:{"name":tab.icon}}):_vm._e(),_vm._v("\n          "+_vm._s(tab.text)+"\n        ")],1)])}),0)]),_c('div',[_vm._t(_vm.value)],2)])}
var staticRenderFns = []

export { render, staticRenderFns }